<script setup lang="ts">
import { computed } from 'vue';
const $slots = defineSlots();
const $props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  border: {
    type: Boolean,
  },
  borderColor: {
    type: String,
  },
  style: {
    type: Object,
  },
});

const styles = computed(() => {
  let style = {};
  if ($props.border && $props.borderColor) {
    //@ts-ignore
    style['borderColor'] = $props.borderColor;
  }

  return { ...style, ...$props.style };
});
</script>

<template>
  <label
    class="x-item flex justify-between items-center rounded-xl px-2.5"
    :class="{ border: $props.border }"
    :style="styles"
  >
    <div class="shrink-1 w-full flex items-center">
      <div v-if="$slots.start" class="mr-[10px] flex items-center">
        <slot name="start"></slot>
      </div>
      <div class="shrink-0 flex items-center">
        <slot></slot>
      </div>
    </div>
    <div class="grow flex items-center" v-if="$slots.end">
      <slot name="end"></slot>
    </div>
  </label>
</template>

<style lang="sass">
.x-item
  height: 50px
  border-radius: var(--radius-10)
  border-color: #a8a8a8
  padding: 0 10px
  & > input
    text-align: right
    outline: none
    &:hover
      border: none
  .el-select .el-input__wrapper,
  .el-select .el-input.is-focus .el-input__wrapper
        padding: 0
        box-shadow: none !important
  .el-select .el-input__wrapper.is-focus
    --el-select-input-focus-border-color: transparent
</style>
